export const RESTRICTED_EMAIL = 'info@cfnumao.com';
export const ALLOWED_PAGE_ID = 7;

let cachedToken = null;
let cachedEmail = null;

const ALLOWED_ROUTE_PREFIXES = [
    '/produtos/lista',
    '/produtos/editar',
    '/paginas/lista',
    '/paginas/editar',
    '/perfil',
    '/logout',
    '/login',
    '/reset-password',
    '/privacypolicy',
    '/404',
    '/500',
];

function decodeJwtPayload(token) {
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64 + '=='.slice(0, (4 - base64.length % 4) % 4);
        const json = decodeURIComponent(
            atob(padded)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    } catch (e) {
        return null;
    }
}

export function getCurrentUserEmail() {
    const raw = localStorage.getItem('user');
    if (!raw) {
        cachedToken = null;
        cachedEmail = null;
        return null;
    }

    try {
        const user = JSON.parse(raw);
        const token = user && user.data && user.data.accessToken;
        if (!token) {
            cachedToken = null;
            cachedEmail = null;
            return null;
        }

        if (token === cachedToken) return cachedEmail;

        const payload = decodeJwtPayload(token);
        const email = payload && (
            payload.email
            || payload.unique_name
            || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']
            || payload.sub
            || payload.nameid
        );

        cachedToken = token;
        cachedEmail = email ? String(email).toLowerCase() : null;
        return cachedEmail;
    } catch (e) {
        return null;
    }
}

export function isRestrictedUser() {
    const email = getCurrentUserEmail();
    return email === RESTRICTED_EMAIL;
}

export function isRestrictedRoute(path) {
    if (!path) return false;
    return !ALLOWED_ROUTE_PREFIXES.some(prefix => path === prefix || path.startsWith(prefix + '/') || path.startsWith(prefix + '?'));
}
